import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X, Phone, MessageCircle } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const heroSection = document.getElementById('home');
      
      if (heroSection) {
        const heroHeight = heroSection.offsetHeight;
        setIsVisible(scrollPosition > heroHeight * 0.3); // Aparece quando rola 30% da hero
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 w-full bg-blue-600/95 backdrop-blur-sm border-b border-blue-500 z-50 transition-transform duration-300 ${
      isVisible ? 'translate-y-0' : '-translate-y-full'
    }`}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src="https://tecnotesjc.com.br/wp-content/uploads/2022/04/logotipo-tecnote-branco-300x53.png" 
              alt="Tecnote Logo" 
              className="h-8 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-blue-100 hover:text-white transition-colors font-medium"
            >
              Início
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-blue-100 hover:text-white transition-colors font-medium"
            >
              Serviços
            </button>
            <button 
              onClick={() => scrollToSection('advantages')}
              className="text-blue-100 hover:text-white transition-colors font-medium"
            >
              Vantagens
            </button>
            <button 
              onClick={() => scrollToSection('projects')}
              className="text-blue-100 hover:text-white transition-colors font-medium"
            >
              Projetos
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-blue-100 hover:text-white transition-colors font-medium"
            >
              Contato
            </button>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-3">
            <Button 
              variant="outline" 
              size="sm" 
              className="text-white border-blue-300 hover:bg-blue-700"
              onClick={() => window.open('tel:5512997176654', '_self')}
            >
              <Phone className="w-4 h-4 mr-2" />
              Ligar
            </Button>
            <Button 
              size="sm" 
              className="bg-green-600 hover:bg-green-700"
              onClick={() => window.open('https://wa.me/5512997176654?text=Olá! Gostaria de uma consultoria para montagem de PC', '_blank')}
            >
              <MessageCircle className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 py-4 border-t border-gray-700">
            <nav className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-left text-blue-100 hover:text-white transition-colors font-medium"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-left text-blue-100 hover:text-white transition-colors font-medium"
              >
                Serviços
              </button>
              <button 
                onClick={() => scrollToSection('advantages')}
                className="text-left text-blue-100 hover:text-white transition-colors font-medium"
              >
                Vantagens
              </button>
              <button 
                onClick={() => scrollToSection('projects')}
                className="text-left text-blue-100 hover:text-white transition-colors font-medium"
              >
                Projetos
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-left text-blue-100 hover:text-white transition-colors font-medium"
              >
                Contato
              </button>
              
              <div className="flex flex-col space-y-2 pt-4 border-t border-gray-700">
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="text-white border-blue-300 hover:bg-blue-700 justify-start"
                  onClick={() => window.open('tel:5512997176654', '_self')}
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Ligar Agora
                </Button>
                <Button 
                  size="sm" 
                  className="bg-green-600 hover:bg-green-700 justify-start"
                  onClick={() => window.open('https://wa.me/5512997176654?text=Olá! Gostaria de uma consultoria para montagem de PC', '_blank')}
                >
                  <MessageCircle className="w-4 h-4 mr-2" />
                  WhatsApp
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;